import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check .env for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export type Franchise = {
  id: number;
  tenant_id: string;
  company_name: string;
  custom_domain: string;
  license_tier: 'DEMO_TEST' | 'SOLO_PRO' | 'AGENCY_SUITE' | 'SYSTEM_OWNER';
  is_active: boolean;
  created_at: string;
};

export type Seat = {
  id: number;
  tenant_id: string;
  user_email: string;
  license_key: string;
  active_status: boolean;
  created_at: string;
};
